import './lidCodes.css'

import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { useTankLidCodes } from '@api/useTankLidCodes'
import { LidCodeForm } from '@components/Admin/Product/ManageLidCodes/LidCodeForm'
import { GraviButton, Horizontal, NothingMessage, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useUserSettings } from '@hooks/settings'
import { Popconfirm, Spin, Tabs } from 'antd'
import React, { useMemo, useState } from 'react'

export function ManageLidCodes({ lidCodes, loading, activeKey, setActiveKey, setAddingNewItem }) {
  const { useLidCodeDeleteMutation } = useTankLidCodes()
  const { updateSetting } = useUserSettings()
  const handleDelete = async (id) => await useLidCodeDeleteMutation.mutateAsync(id)

  const systemDefaultLidCodes = useMemo(() => {
    if (!lidCodes) return []
    return lidCodes.filter((lidCode) => lidCode.is_system_default).sort((a, b) => a.name.localeCompare(b.name))
  }, [lidCodes])

  const customLidCodes = useMemo(() => {
    if (!lidCodes) return []
    return lidCodes.filter((lidCode) => !lidCode.is_system_default).sort((a, b) => a.name.localeCompare(b.name))
  }, [lidCodes])
  const updateStickyTab = (key) => {
    setActiveKey(key)
    updateSetting('manage-tank-lid-code-active-tab', key)
  }

  return (
    <Tabs activeKey={activeKey} defaultActiveKey={activeKey || '1'} onChange={updateStickyTab}>
      <Tabs.TabPane tab='System Defaults' key='1'>
        <hr style={{ marginTop: '-2px' }} className='lid-codes-form-hr' />
        {loading ? (
          <Horizontal className='p-5' horizontalCenter verticalCenter>
            <Spin spinning />
          </Horizontal>
        ) : !systemDefaultLidCodes?.length ? (
          <NothingMessage title='No Lid Codes Found' />
        ) : (
          systemDefaultLidCodes?.map((lidCode) => <LidCodeItems lidCodeItem={lidCode} areDefault key={lidCode?._id} />)
        )}
      </Tabs.TabPane>
      <Tabs.TabPane tab='Custom' key='2'>
        <hr style={{ marginTop: '-2px' }} className='lid-codes-form-hr' />
        {loading ? (
          <Horizontal className='p-5' horizontalCenter verticalCenter>
            <Spin spinning />
          </Horizontal>
        ) : !customLidCodes?.length ? (
          <NothingMessage title='No Lid Codes Found' />
        ) : (
          customLidCodes?.map((lidCode) => (
            <LidCodeItems key={lidCode?._id} lidCodeItem={lidCode} handleDelete={handleDelete} />
          ))
        )}
      </Tabs.TabPane>
    </Tabs>
  )
}

export function LidCodeItems({ lidCodeItem = null, handleDelete, areDefault = false }) {
  const [isEditing, setIsEditing] = useState(false)
  const handleClose = () => {
    setIsEditing(false)
  }
  return (
    <>
      {isEditing ? (
        <LidCodeForm lidCodeItem={lidCodeItem} handleClose={handleClose} />
      ) : (
        <Horizontal className='p-2 border-bottom' verticalCenter>
          <Vertical flex={1}>
            <img alt='image' src={lidCodeItem.image_url} style={{ width: '50px' }} className='mr-4' />
          </Vertical>
          <Vertical flex={2} alignItems='start'>
            <Texto category='h6'>{lidCodeItem.name}</Texto>
            <Horizontal verticalCenter>
              <div
                className='mr-1 bordered'
                style={{ height: '12px', width: '12px', backgroundColor: lidCodeItem.color_hex }}
              />
              <Texto textTransform='uppercase'>{lidCodeItem.color_hex}</Texto>
            </Horizontal>
          </Vertical>
          <Horizontal flex={1}>
            {!areDefault && (
              <>
                <GraviButton
                  className='ghost-gravi-button'
                  onClick={() => setIsEditing(true)}
                  icon={<EditOutlined />}
                />
                <Popconfirm
                  title={`Are you sure you want to delete ${lidCodeItem.name}?`}
                  onConfirm={() => handleDelete(lidCodeItem._id)}
                  icon={<QuestionCircleOutlined style={{ color: 'var(--theme-error)' }} />}
                >
                  <GraviButton className='ml-2' appearance='solid' error icon={<DeleteOutlined />} />
                </Popconfirm>
              </>
            )}
          </Horizontal>
        </Horizontal>
      )}
    </>
  )
}
